import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `PanelControl`, method: 'GET', body: null})
}
